import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

// admins
import admins from "./admin/reducer"

//roles
import roles from "./roles/reducer"

//tasks
import users from "./user/reducer"

//Dasboard
import dashboard from "./dashboard/reducer"

//Carpark
import carPark from "./carpark/reducer"

//Season Pass
import seasonPass from "./season-pass/reducer"

//guest
import guests from "./guest/reducer"

//Audits
import auditTicket from "./audit/reducer"

//Bills
import bills from "./bill/reducer"

//Settings
import Settings from "./settings/reducer"
//Carpark/Session Tickets
import sessionTickets from "./tickets/reducer"

//Special Date
import SpecialDates from "./specialdates/reducer"


//blacklists
import blacklists from "./blacklists/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  roles,
  users,
  dashboard,
  carPark,
  seasonPass,
  guests,
  auditTicket,
  bills,
  Settings,
  sessionTickets,
  admins,
  SpecialDates,
  blacklists,
})

export default rootReducer
